export function setEventAttendees(state, eventAttendees) {
    state.eventAttendees = eventAttendees;
}